import React from 'react';
import Image from 'next/image';
import cx from 'classnames';

import styles from './AboutUsSection.module.scss';

const AboutUsMain = ({ data }: { data: any }): JSX.Element => {
  return (
    <div
      className={cx(
        'grid lg:grid-cols-2 grid-cols-1 bg-brand-100',
        styles.container,
      )}
    >
      <div className="lg:pr-[80px] pb-8">
        <Image
          className="w-full rounded"
          width={490}
          height={570}
          src="/images/aboutUs1.webp"
          alt="About us image"
        />
        <Image
          className="w-full rounded mt-2"
          width={490}
          height={570}
          src="/images/aboutUs2.webp"
          alt="About us image"
        />
        <Image
          className="w-full rounded mt-2"
          width={490}
          height={570}
          src="/images/aboutUs3.webp"
          alt="About us image"
        />
      </div>

      <div>
        <div className="mb-3">
          <h2 className="text-white font-bold">{data.main.title}</h2>
        </div>
        <p className="text-gray-800 text-lg">{data.main.description}</p>
        <div className="my-10">
          <h2 className="text-white font-bold">{data.whyChoose.title}</h2>
        </div>
        <div>
          <ul className="flex flex-col gap-y-10">
            {data.whyChoose.pointers?.map(
              ({ description }: { description: string }, index: number) => (
                <li
                  className="flex items-baseline"
                  key={`description-${index}`}
                >
                  <Image
                    width={14}
                    height={10}
                    src="/icons/checkmark.svg"
                    alt="Checkmark icon"
                    className="mr-4 h-[14px] w-[10px]"
                  />
                  <p className="text-white text-lg">{description}</p>
                </li>
              ),
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUsMain;
